import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** Legacy route — publish review iframe now loads the live vendor portal in preview mode. */
const VendorPortalPreviewPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const reloadToken = searchParams.get('k') ?? String(Date.now());
  return <Navigate to={`/vendor-portal?publishPreview=1&k=${encodeURIComponent(reloadToken)}`} replace />;
};

export default VendorPortalPreviewPage;
